export default __webpack_public_path__ + "media/color/eur-5bf63c01.svg";